import ModalState from "reusable/mobx-helpers/ModalState"
import { makeAutoObservable } from "mobx"

interface GapMindsetPluginStoreProps {
   insertDirective: (directive: any) => void
}

export default class GapMindsetPluginStore {
   sp
   modalState = new ModalState()

   constructor(sp: GapMindsetPluginStoreProps) {
      makeAutoObservable(this)
      this.sp = sp
   }

   insertMindsetImage = (mindsetId: string, orgId: string) => {
      this.sp.insertDirective({
         name: 'GapMindset',
         type: 'leafDirective',
         attributes: { id: mindsetId, orgId },
      })
      this.modalState.close()
   }
}
